const React = require('react');
const marked = require('marked');
const { useParams } = require('react-router-dom');
const Prism = require('prismjs');

const { fetchData, replacePaths } = require('../../dataHelper');
const ArticleView = require('./ArticleView');

const notFoundHtml = `<h1>The requested article was not found</h1>
<p>The article may have moved. If so, please try looking in the sidebar for content you were looking for.</p>
<p>Sorry for the inconvenience!</p>
`;

async function loadArticle(file) {
  let url = file.startsWith('http') ? file : `doc/${file}`;
  if (!url.endsWith('.md')) {
    url = url + '.md';
  }

  const download = url.startsWith('http') ? await fetch(url) : await fetchData(url);
  if (!download.ok) throw(new Error('Failed to load article'));
  const markdown = await download.text();
  return marked(replacePaths(markdown));
}

function jumpToHash() {
  const hash = location.hash.replace('#', '');
  if (hash) {
    document.getElementById(hash)?.scrollIntoView();
  }
}

function findHeadings(selector = 'h2') {
  const els = Array.from(document.querySelectorAll(selector));
  return els.map(el => ({ id: el.id, name: el.innerText }));
}

const Article = (props) => {
  const { folder, article } = useParams();
  const { print } = props;

  const [{ name, html }, setArticle] = React.useState({ name: 'HomePage', html: 'Loading...' });
  const [toc, setToc ] = React.useState([]);

  const externalUrl = new URLSearchParams(location.search).get('ext');

  const newName = externalUrl || (folder ? folder + '/' + article : article);

  // we dont want to parse markdown for every single render, only when article change:
  if (name !== newName) {
    loadArticle(newName)
      .then((html) => {
        setArticle({ name: newName, html });
        Prism.highlightAll();
        setToc(findHeadings());
        jumpToHash();
      })
      .catch(() => setArticle({ name: newName, html: notFoundHtml }));
  }

  const printUrl = `/print/${newName}`;
  // key ensures we scroll to top when loading new articles
  return (
    <ArticleView html={html} key={newName} toc={toc} print={print} printUrl={printUrl} />
  );
}

module.exports = Article;
